import { Action, Module, VuexModule } from "vuex-module-decorators";
import { SpeakerLog } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class SpeakerLogModule extends VuexModule {
    @Action
    [SpeakerLog.getSpeakerLogList]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/log/speakers/list`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [SpeakerLog.findPageSpeakerLog](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/log/speakers`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [SpeakerLog.saveSpeakerLog](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/log/speakers/save`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

        @Action
    [SpeakerLog.deleteSpeakerLog](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/log/speakers/delete`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

}